import { z } from 'zod'

export const recommendationsOpenedSchema = z.object({
  newRecommendations: z.number(),
})
